import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useGetCustomersQuery } from "./customersApiSlice";
import { memo } from "react";
import useLang from "../../hooks/useLang";
import useTranslate from "../../hooks/useTranslate";

// import `ChakraProvider` component
import {
	Icon,
	IconButton,
	Tr,
	Td,
	Tooltip,
	Image,
	Text,
	Box,
	AspectRatio,
	HStack,
} from "@chakra-ui/react";

// import `ChakraProvider` icon
import { CheckIcon, CloseIcon, EditIcon } from "@chakra-ui/icons";

const Customer = ({ customerId }) => {
	const { lang } = useLang();
	const { T } = useTranslate(lang);

	const { customer } = useGetCustomersQuery("customersList", {
		selectFromResult: ({ data }) => ({
			customer: data?.entities[customerId],
		}),
	});

	const navigate = useNavigate();

	if (customer) {
		const handleEdit = () => navigate(`/dash/customers/${customerId}`);

		return (
			<Tr _hover={{ color: "#333333", border: "2px", borderColor: "teal.600" }}>
				<Td>
					{customer.customerStatus ? (
						<Icon
							as={CheckIcon}
							w={4}
							h={4}
							color="green.500"
							title={T.common.Actived}
						/>
					) : (
						<Icon
							as={CloseIcon}
							w={4}
							h={4}
							color="red.500"
							title={T.common.Disabled}
						/>
					)}
				</Td>

				<Td>
					<HStack>
						{customer.customerPics ? (
							<Image
								src={`https://api.oracly.svppb.com/images/${customer.customerPics[0]}/display`}
								maxW="75px"
							/>
						) : (
							<Image src="" h="50" />
						)}
						<div>
							<Text fontSize={20} fontWeight={700}>
								{customer.customerName[lang]}
							</Text>
						</div>
					</HStack>
				</Td>

				<Td>{customer.customerType}</Td>

				<Td>{customer.customerGenre}</Td>

				<Td isNumeric>
					<Tooltip
						hasArrow
						label={T.common.Edit}
						bg="gray.300"
						closeOnClick={true}
						color="black"
						placement="left"
					>
						<IconButton
							colorScheme="gray"
							aria-label="New"
							icon={<EditIcon />}
							onClick={handleEdit}
							_hover={{
								bg: "teal.600",
								color: "white",
								borderColor: "teal.600",
							}}
						/>
					</Tooltip>
				</Td>
			</Tr>
		);
	} else return null;
};

const memoizedCustomer = memo(Customer);

export default memoizedCustomer;
